import AppConfiguration from '@hal.common.ui/utilities/AppConfig';
import { BarcodeReader } from 'dynamsoft-javascript-barcode';
export class DynamsoftConfig {
    public static LoadConfiguration(): void {
        // Free 30 day trial - Expiration Date 2022-07-20
        BarcodeReader.license = AppConfiguration.GetConfiguration('DYNAMSOFT_CONFIG').license;
        BarcodeReader.engineResourcePath = AppConfiguration.GetConfiguration('DYNAMSOFT_CONFIG').engineResourcePath;
    }
}
